<h1 class="messageDisplay" mat-dialog-title>Message</h1>
<div mat-dialog-content *ngIf="!choice">
  <p>{{data.Message}}</p>
  <p> Waiting for next file from Device. Next file should arrive within <strong>{{display}}</strong> 
    minutes. Please wait..</p>

</div>
<div mat-dialog-content *ngIf="choice">
  <p>{{data.Message}}</p>

</div>
<div mat-dialog-actions>
  
  <button mat-button *ngIf="!choice"  (click)="onCancelClick()" class="btn primary_btn">Stop Calibration</button>
  <button *ngIf="choice" (click)="onclickyes('yes')">YES</button>
  <button mat-raised-button
    matTooltip="Stop Calibration"
    aria-label="Button that displays a tooltip when focused or hovered" 
    *ngIf="choice"  (click)="onclickno('no')">
    NO
  </button>
  <!-- <button mat-button [mat-dialog-close]="data.animal" cdkFocusInitial>Ok</button> -->
</div>
